export const splitStreet = (street) => {
  if (typeof street === 'string') {
    return street || '';
  }

  return street ? street.toString().replace(/, ?/g, '\r\n') : [];
};
